// Dependencies
var _ = require('underscore');
var Marionette = require('backbone.marionette');

// App
var errorTpl = require('./templates/error.html');
var Template = require('app/utils/template');

var ErrorView = Marionette.ItemView.extend({
    className: 'error-view well',

    getTemplate: function() {
        if (this.getOption('template')) {
            return Template(this.getOption('template'));
        }
        return Template(errorTpl);
    },

    messageTitles: {
        404: 'Page Not Found',
        403: 'Forbidden',
        500: 'Server Error',
    },

    messages: {
        404: 'We could not find the page you are looking for.',
        403: 'The page or action you requested is not allowed.',
        500: "Something went wrong on our end. We'll be working on a fix shortly.",
    },

    ui: {
        errorTitle: '[data-ui="errorTitle"]',
        errorMessage: '[data-ui="errorMessage"]',
    },

    initialize: function(options) {
        var options = options || {};

        if (_.isUndefined(options.errorCode)) {
            throw new Error('errorCode required');
        }
    },

    serializeData: function() {
        var errorCode = this.options.errorCode;

        return {
            errorMessage: this.options.title || this.messageTitles[errorCode],
            message: this.options.message || this.messages[errorCode],
            errorCode: errorCode,
        };
    },
});

module.exports = ErrorView;
